export const SET_PAGE_NOW = "SET_PAGE_NOW";
export const SET_MENU_MODE = "SET_MENU_MODE";
export const SET_MENU_MOBILE = "SET_MENU_MOBILE";